function ClickOpenChat() {
  $('[data-open-chat]').on('click', () => {
    if (window.fcWidget) {
      window.fcWidget.open();
    }
  });
}

exports.init = ClickOpenChat;
